import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';
import { CATEGORY_OPTIONS, TERM_STATUS } from './credit-product.enums';
/** `CreditProductContainer.tsx:89-110` + `ProdutFilters.tsx:20-27`, na ordem do select do legado. */
export const creditProductFilters = defineFilters([
  {
    key: 'searchString',
    type: 'search',
    label: msg`Todos`,
    placeholder: msg`Buscar produtos de crédito`,
  },
  {
    key: 'categoryName',
    type: 'select',
    label: msg`Categoria do produto`,
    options: CATEGORY_OPTIONS.map((option) => ({ value: option.value, label: option.label })),
  },
  { key: 'amortizationType', type: 'text', label: msg`Tipo de amortização` },
  { key: 'name', type: 'text', label: msg`Nome do produto` },
  {
    key: 'initialDate',
    to: 'finalDate',
    type: 'dateRange',
    label: msg`Data da ocorrência`,
    fromLabel: msg`De`,
    toLabel: msg`Até`,
    // O legado mostra o fim, mas sem `dateRangeName` não o envia (`contexts/filterContext.tsx:117`).
    sendTo: false,
  },
  { key: 'termStatus', type: 'select', label: msg`Status de vigência`, options: TERM_STATUS },
]);
